// extracted by mini-css-extract-plugin
module.exports = {"AperturaContainerXL-parent":"styles_AperturaContainerXL-parent__Y_j92","primer-bloque":"styles_primer-bloque__aPqpW"};